import React, { useState, useEffect } from 'react';
import styles from './viewOneWayInterviewGroup.module.scss';
import ReactGA from 'react-ga';
import { Helmet } from "react-helmet";
import CustomNavbar from '../../customNavbar';
import { Accordion, Card, Col, Row, Button } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { dropdownIcon } from '../../../shared/customIcons/Icons';
import CSSLoader from '../../../shared/cssLoader';
import { getAllOneWayInterviewGroupDetails } from '../../../../services/util/oneWayInterview';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import { CustomStatusLabel } from '../../../shared/customStatusLabel';
import { CustomSearch } from '../../../shared/customSearch';
import { CustomButton } from '../../../shared/customButton';
import Avatar from 'react-avatar';
let moment = require('moment-timezone');

function ViewOneWayInterviewGroup(props) {
    let [accordionIcon, setAccordionIcon] = useState(true);
    let [candidateList, setCandidateList] = useState([]);
    let [commonData, setCommonData] = useState({});
    let [filteredValues, setFilteredValues] = useState([]);
    let [isURLLoading, setURLLoading] = useState(false);
    const [isLoading, setLoading] = useState(false);
    let [getUsersIsLoading, getUsersSetLoading] = useState(false);

    const breadcrumb = [
        {
            pathaddress: '/app/company/one-way-interviews',
            pathname: 'One Way Interviews',
            isActive: false,
            key: 1 + 'One Way Interview'
        },
        {
            pathaddress: '',
            pathname: commonData.step_name,
            isActive: true,
            key: 1 + commonData.step_name
        }
    ];

    const changeAccordionIcon = () => {
        setAccordionIcon(!accordionIcon)
    }

    const ViewOneWayInterview = (values) => {
        props.history.push(`/app/company/one-way-interviews/${values}`);
    }

    //searching one way interviews
    function searchValues(searchValue) {
        let searchVal = searchValue.toLowerCase();
        if (searchValue == '') {
            setCandidateList(filteredValues)
        } else {
            const filtered = filteredValues.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
            setCandidateList(filtered);
        }

    }

    async function loadInitialData() {
        setLoading(true);
        //getting query parameter value
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let step_id = params.get('step_id');
        if (step_id) {
            let respond = await getAllOneWayInterviewGroupDetails(step_id);
            if (respond.success === true) {
                if (respond.data && respond.data.common_details && respond.data.candidate_object_list) {
                    setCommonData(respond.data.common_details);
                    setCandidateList(respond.data.candidate_object_list);
                    setFilteredValues(respond.data.candidate_object_list);
                    setLoading(false);
                } else {
                    props.history.push(`/app/company/one-way-interviews`);
                }
            } else {
                props.history.push(`/app/company/one-way-interviews`);
                setLoading(false);
            }
        }
    }

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(candidateList.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(candidateList.length / itemsPerPage);

    useEffect(() => {
        loadInitialData();
    }, [])

    useEffect(() => {
        let pageHit = '/app/company/one-way-interviews';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_GOOGLE_ANALYTICS_ID}`);
        ReactGA.pageview(pageHit);
    }, [])

    return (
        <div>
            <Helmet>
                <title>One Way Interview | HireTrace</title>
            </Helmet>
            {isLoading ?
                <div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>
                :
                <div>

                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
                    </div>

                    <div className={styles.BodyContainer}>
                        <Col>
                            <Col className="mt-3">
                                <div>
                                    <Row>
                                        <Col sm={6} className="mb-2">
                                            <p className={styles.tableSecondJobDetails}>{commonData.pipeline_name} | {commonData.hiring_position} | {commonData.step_name}</p>
                                        </Col>
                                        <Col sm={6} className="mb-2">
                                            <CustomSearch
                                                placeholder="Search by name"
                                                handleOnChange={(e) => searchValues(e.target.value)}
                                            />
                                        </Col>

                                    </Row>
                                </div>
                            </Col>


                            <div className={styles.tableContainer}>
                                <div className={styles.tableFirstRowMainHeaderDiv}>
                                    <Col sm={4} className={styles.tablePipelineDetailsMainHeaderRow}>
                                        <p>Candidate Details</p>
                                    </Col>
                                    <Col sm={2} className={styles.tableStstusDetailsMainHeaderRow}>
                                        <p>Status</p>
                                    </Col>
                                    <Col sm={2}>
                                        <Row className={styles.tableInfoDetailsMainHeaderRow}>
                                            <p>Submitted Date and Time</p>
                                        </Row>
                                    </Col>
                                    <Col sm={1}>
                                        <Row className={styles.tableShareLinksHeaderRow}>
                                            <p>Passing Threshold</p>
                                        </Row>
                                    </Col>
                                    <Col sm={3}>
                                        <Row className={styles.tableCandidatesInfoDetailsHeaderRow}>
                                            <p>Review</p>
                                        </Row>
                                    </Col>
                                </div>
                                {candidateList?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((oneWayInterview, i) => {
                                    return (
                                        <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                            <Col sm={4}>
                                                <Row className={styles.tableJobDetailsMainRow}>
                                                    <Col sm={2}>
                                                        <Avatar name={oneWayInterview.candidate_name} size="32" round={true} />
                                                    </Col>
                                                    <Col sm={10}>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableJobDetails}>{oneWayInterview?.candidate_name}</p>
                                                        </Row>
                                                        <Row className={styles.tableJobDetailsRow}>
                                                            <p className={styles.tableSecondJobDetails}>{oneWayInterview?.candidate_email}</p>
                                                        </Row>
                                                    </Col>

                                                </Row>

                                            </Col>
                                            <Col sm={2} className='d-flex align-items-center justify-content-center'>
                                                <CustomStatusLabel type={oneWayInterview.state === 5 ? 'successStatus' : oneWayInterview.state === 0 ? 'warningStatus' : 'dangerStatus'} label={oneWayInterview.state === 5 ? 'Submitted for marking' : oneWayInterview.state === 0 ? 'Waiting for answer' : oneWayInterview.state === -40 ? 'Expired' : oneWayInterview.state !== 0 ? 'Waiting for answer' : null}></CustomStatusLabel>
                                            </Col>
                                            <Col sm={2}>
                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                    <p className={styles.tableCandidatesInfoDetails}>{oneWayInterview?.candidate_submit_date ? moment(oneWayInterview?.candidate_submit_date).format('DD MMM YYYY, HH:mmA') : " - "}</p>
                                                </Row>
                                            </Col>
                                            <Col sm={1}>
                                                <Row className={styles.tableCandidatesInfoDetailsRow}>
                                                    <p className={styles.tableCandidatesInfoDetails}>{commonData.pass_score}%</p>
                                                </Row>
                                            </Col>
                                            <Col sm={3}>
                                                <Row className={styles.tableCandidatesInfoDetailsButtonRow}>
                                                    <CustomButton
                                                        buttonType="button"
                                                        label="Review Candidate"
                                                        type="secondaryBtn"
                                                        backicon={
                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }
                                                        handleClick={() => ViewOneWayInterview(oneWayInterview.one_way_interview_session_id)}
                                                        // disabled={!oneWayInterview?.candidate_submit_date}
                                                        // showToolTip={!oneWayInterview?.candidate_submit_date}
                                                        disabled={oneWayInterview?.state === 0 || oneWayInterview?.state === -40 || oneWayInterview?.state === 3}
                                                        showToolTip={oneWayInterview?.state === 0 || oneWayInterview?.state === -40 || oneWayInterview?.state === 3}
                                                        toolTip={`waiting for submit answers`}
                                                        toolTipId={`submit_answers`}
                                                        toolTipType={"dark"}
                                                    />
                                                </Row>
                                            </Col>
                                        </div>
                                    );

                                })
                                }
                                {candidateList.length > 9 && getUsersIsLoading === false &&
                                    <div className={styles.bottomTableDiv}>
                                        <div>
                                            <button
                                                onClick={handlePreviousClick}
                                                disabled={currentPage === 1}
                                                className={styles.paginationPrevButton}
                                            >
                                                Previous
                                            </button>
                                            <button
                                                onClick={handleNextClick}
                                                disabled={currentPage === Math.ceil(candidateList.length / itemsPerPage)}
                                                className={styles.paginationNextButton}
                                            >
                                                Next
                                            </button>
                                        </div>
                                        <div>
                                            <span className={styles.paginationInfo}>
                                                Page {currentPage} of {totalPages}
                                            </span>
                                        </div>

                                    </div>
                                }
                            </div>

                        </Col>
                    </div>
                </div>
            }
        </div>
    )
}

export default ViewOneWayInterviewGroup;
